export default "/images/twitter-logo.png?92127c2ae099baf2eaf17c9e44a03248";